export type MetaAttribute = 'name' | 'property';

export function upsertMetaTag(
  attribute: MetaAttribute,
  key: string,
  content: string,
  extraAttributes: Record<string, string> = {}
) {
  let element = document.head.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`
  );

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  for (const [name, value] of Object.entries(extraAttributes)) {
    element.setAttribute(name, value);
  }

  element.setAttribute('content', content);
  return element;
}
